export const projects = [
    {
        title: "A Few Mad Apples",
        slug: "a-few-mad-apples",
        genre: "Documentary",
        length: "50 min",
        rating: "R",
        status: "Development",
        projectIntro:
            "A documentary in development tracing how policing and mass incarceration fracture Black families, with a focus on history, grief, survival, and resistance.",
        logline:
            "When badges tear families apart, can communities build a shield strong enough to heal?",
        synopsis: [
            "Across the United States, nearly 5 million children have experienced the incarceration of a parent. For Black children, the odds are devastatingly higher: they are nearly five times more likely than white children to lose a mother or father to the system. A Few Mad Apples dismantles the comforting myth that family separation is the work of “a few bad apples.” Instead, it reveals an unbroken line from slave patrols to modern policing—a system designed to fracture Black families and criminalize Black parenthood.",
        ],
        backgroundImage: "/assets/Project1BGImage.jpg",
        tags: ["mass incarceration", "activism", "Black Lives Matter", "documentary"],
        websiteUrl: "",
        pitchDeckUrl: "",
        donateUrl: "",
        socials: {
            instagram: "",
            facebook: "",
        },
    },
    {
        title: "Shantasia",
        slug: "shantasia",
        genre: "Animated Comedy",
        length: "9x12 min series",
        rating: "TV-MA",
        status: "Development",
        projectIntro:
            "An animated comedy series in development about workplace absurdity, performative politics, and a Black filmmaker turning startup chaos into her own survival story.",
        logline:
            "A filmmaker stuck as the token Black hire at a fake woke Brooklyn startup fights back with her camera, turning office chaos into a hit documentary with backup from her loud, loving, polyamorous crew.",
        synopsis: [
            "Snackly Tech is the kind of startup where the CEO posts motivational quotes about “disrupting inequality” while the office printer literally catches fire every Tuesday. Shantasia takes the job because her camera dreams need funding and Brooklyn rent is basically financial terrorism. What she doesn’t expect is being promoted to “Chief Vibes Officer,” mostly so she can explain to her team that just because Justin Bieber said “it’s not clocking to you that I’m standing on business,” doesn’t mean it belongs in the onboarding manual.",
        ],
        backgroundImage:
            "https://5688825.fs1.hubspotusercontent-na1.net/hubfs/5688825/meshaestudios.com/Shantasia.png",
        tags: ["Diversity and Inclusion", "Web Series", "Animation"],
        websiteUrl: "",
        pitchDeckUrl: "",
        donateUrl: "",
        socials: {
            instagram: "",
            facebook: "",
        },
    },
    {
        title: "Assigned Sex",
        slug: "assigned-sex",
        genre: "Podcast",
        length: "16 Episodes",
        rating: "TV-MA",
        status: "Production",
        projectIntro:
            "A podcast in production centering Black trans and genderqueer voices in conversations about identity, faith, embodiment, and the systems built to silence them.",
        logline:
            "Black trans and genderqueer voices on identity, bodies, faith, and the systems designed to silence us.",
        synopsis: [
            "A podcast hosted by Shaun Dawson, featuring intimate conversations on Black trans and genderqueer experiences regarding identity, faith, and breaking binary gender roles. The series, which launched in early 2026 as a follow-up to a 2019 film project, highlights topics like queer joy, navigating faith, and historical queer figures.",
        ],
        backgroundImage:
            "https://5688825.fs1.hubspotusercontent-na1.net/hubfs/5688825/meshaestudios.com/Assigned%20Sex%20Podcast%20Episode%204%20(1).png",
        tags: ["Podcast", "LGBTQ"],
        websiteUrl: "https://assignedsex.substack.com",
        pitchDeckUrl: "",
        donateUrl: "",
        socials: {
            instagram: "https://instagram.com/assignedsex",
            facebook: "https://facebook.com/assignedsex",
        },
    },
];
